/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateJSONWebKeySetForm = {
  /**
   * The external key to back the set with. Must be a live, organization-owned GCP KMS key; AWS KMS keys are not supported yet.
   */
  externalKeyId: string;
  /**
   * A human-readable name for the key set. Names may repeat within an organization.
   */
  name: string;
};

/** @internal */
export type CreateJSONWebKeySetForm$Outbound = {
  external_key_id: string;
  name: string;
};

/** @internal */
export const CreateJSONWebKeySetForm$outboundSchema: z.ZodMiniType<
  CreateJSONWebKeySetForm$Outbound,
  CreateJSONWebKeySetForm
> = z.pipe(
  z.object({
    externalKeyId: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      externalKeyId: "external_key_id",
    });
  }),
);

export function createJSONWebKeySetFormToJSON(
  createJSONWebKeySetForm: CreateJSONWebKeySetForm,
): string {
  return JSON.stringify(
    CreateJSONWebKeySetForm$outboundSchema.parse(createJSONWebKeySetForm),
  );
}
